import type { PmNodeConverter, PmNodeJson } from './../../pm-converters/types';
import type { Node, ParagraphData } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import blockquoteDefaultData from './../../ricos-schema/legacy/statics/blockquote.defaults.json';
import type { BlockquoteNode, ParagraphNode, TextNode } from './../../ricos-types';

type ParagraphFields = {
  paragraphData: ParagraphData;
  paragraphId: string;
};

const toParagraphFields = (node: ParagraphNode): ParagraphFields => {
  const { id: paragraphId, paragraphData = {} } = node;
  return { paragraphData, paragraphId };
};

const toParagraphNode =
  (fields: ParagraphFields) =>
  (nodes: TextNode[]): ParagraphNode => {
    return {
      id: fields.paragraphId,
      type: Node_Type.PARAGRAPH,
      paragraphData: fields.paragraphData,
      nodes,
    };
  };

export const blockquoteConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.BLOCKQUOTE],
    // @ts-expect-error $TSFixMe
    convert: (node: BlockquoteNode, visit: (node: ParagraphNode) => PmNodeJson[]) => {
      const { id, style, blockquoteData } = node || {};
      const { paragraphData, paragraphId } = toParagraphFields(node.nodes[0]);
      return {
        type: Node_Type.BLOCKQUOTE,
        attrs: {
          paragraphId,
          textStyle: paragraphData.textStyle,
          indentation: blockquoteData?.indentation ?? blockquoteDefaultData.indentation,
          ...(style ? { style } : {}),
          id,
        },
        // skip internal paragraph, go to text nodes
        content: visit(node.nodes[0]),
      };
    },
  },
  fromPm: {
    types: [Node_Type.BLOCKQUOTE],
    // @ts-expect-error $TSFixMe
    convert: (node: PmNodeJson, visit: (node: PmNodeJson) => Node[]) => {
      const { id, style, paragraphId, textStyle, indentation } = node.attrs || {};
      const paragraphNode = toParagraphNode({
        paragraphData: { indentation: 0, textStyle },
        paragraphId,
      })(visit(node) as TextNode[]);
      return {
        type: Node_Type.BLOCKQUOTE,
        id,
        nodes: [paragraphNode],
        ...(style ? { style } : {}),
        blockquoteData: {
          indentation,
        },
      };
    },
  },
};
